import React from 'react';
import Icon from '../../../components/AppIcon';

const MarketOverviewCards = () => {
  const marketData = [
    {
      id: 1,
      title: "Total Market Cap",
      value: "$2.47T",
      change: "+2.34%",
      changeType: "positive",
      icon: "TrendingUp",
      description: "24h change"
    },
    {
      id: 2,
      title: "Bitcoin Dominance",
      value: "54.2%",
      change: "-0.8%",
      changeType: "negative",
      icon: "PieChart",
      description: "Market share"
    },
    {
      id: 3,
      title: "Fear & Greed Index",
      value: "72",
      change: "Greed",
      changeType: "neutral",
      icon: "Activity",
      description: "Market sentiment"
    },
    {
      id: 4,
      title: "24h Volume",
      value: "$89.2B",
      change: "+12.5%",
      changeType: "positive",
      icon: "BarChart3",
      description: "Trading volume"
    }
  ];

  const getChangeColor = (type) => {
    switch (type) {
      case 'positive': return 'text-success';
      case 'negative': return 'text-error';
      default: return 'text-accent';
    }
  };

  const getIconColor = (type) => {
    switch (type) {
      case 'positive': return 'var(--color-success)';
      case 'negative': return 'var(--color-error)';
      default: return 'var(--color-accent)';
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {marketData?.map((item) => (
        <div key={item?.id} className="bg-card border border-border rounded-lg p-6 hover:shadow-elevation-2 transition-standard">
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 bg-muted rounded-lg flex items-center justify-center">
              <Icon name={item?.icon} size={24} color={getIconColor(item?.changeType)} />
            </div>
            <span className={`text-sm font-medium ${getChangeColor(item?.changeType)}`}>
              {item?.change}
            </span>
          </div>
          <h3 className="text-2xl font-semibold text-card-foreground mb-1">{item?.value}</h3>
          <p className="text-sm text-muted-foreground mb-1">{item?.title}</p>
          <p className="text-xs text-muted-foreground">{item?.description}</p>
        </div>
      ))}
    </div>
  );
};

export default MarketOverviewCards;